export default "/assets/brain-397df1601e89536ce836d2ad12ebfb880bc11b460c1ac0fde95f1b7b97d65350.svg";